import { ApiService } from "../..";

export const fetchSampleList = (fields?: string[]) => {
  return ApiService.baseAction(
    "sample/list/full",
    {
      params: {
        fields,
      },
    },
    "get"
  );
};
